export default {
title: 'AELU',
ssv: 'visa kỹ năng đặc định',
what_ssv: 'Visa kỹ năng đặc định là',
representative_message: 'tin nhắn đại diện',
aeru_feature: 'Đặc trưng của AELU',
aeru_how_to_use: 'Quá trình sử dụng',
aeru_q_a: 'Q&A',
aeru_function: 'Vai trò của AELU',
aeru_fee: 'tiền phí của AELU',
login: 'Đăng nhập',
db_top_comment1: 'Đầu tiên trong ngành! Trang web đào tạo trực tuyến trên điện thoại thông minh "kỳ thi kiểm tra trình độ visa kỹ năng đặc định"',
db_top_comment2: 'AELU là một dịch vụ web cung cấp hỗ trợ cho việc xin visa kỹ năng đặc định bằng cách luyện thi, thông tin về kỳ thi và đăng ký.',
db_top_pr: 'sử dụng "visa kỹ năng đặc định" để nắm bắt cơ hội mới',
member_regist: 'Đăng ký thành viên',
registration_support_organization: 'Cơ quan hỗ trợ đăng ký là gì?',
rso_dec1: 'Trong chế độ kỹ năng đặc định, có 2 cơ quan là "cơ quan trực thuộc kỹ năng đặc định" và "cơ quan hỗ trợ đăng ký". Cơ quan trực thuộc kỹ năng đặc định là công ty tuyển dụng người nước ngoài có kỹ năng đặc định (cơ quan tiếp nhận). Cơ quan trực thuộc kỹ năng đặc định phải hỗ trợ những người nước ngoài có kỹ năng đặc định trong môi trường làm việc, cuộc sống thường ngày và xã hội.',
rso_dec2: 'việc hỗ trợ người nước ngoài có kỹ năng đặc định cũng có nội dung mang tính chuyên môn, nên cũng có những trường hợp khó mà tự mình thực hiện "cơ quan trực thuộc kỹ năng đặc định" công ty tuyển dụng người nước ngoài có kỹ năng đặc định. Cơ quan hỗ trợ đăng ký là cơ quan được ủy thác cho cơ quan trực thuộc kỹ năng đặc định, thực hiện và lập kế hoạch hỗ trợ cho người nước ngoài có kỹ năng đặc định.',
rso_dec3: 'Cơ quan hỗ trợ đăng ký là cơ quan được ủy thác cho cơ quan trực thuộc kỹ năng đặc định để tiến hành thực hiện và lập kế hoạch hỗ trợ cho người nước ngoài có kỹ năng đặc định.',
rso_dec4: 'dựa trên hợp đồng ủy thác hỗ trợ với cơ quan tiếp nhận, cơ quan hỗ trợ đăng ký sẽ tiến hành thực hiện toàn bộ việc hỗ trợ dựa trên kế hoạch hỗ trợ người nước ngoài có kỹ năng đặc định số 1.',
rso_dec5: 'để trở thành một cơ quan hỗ trợ đăng ký, cần phải đăng ký với bộ trưởng cục quản lý xuất nhập cảnh.',
rso_dec6: 'cơ quan đã tiếp nhận đăng ký sẽ được đăng ký trong sổ đăng ký của cơ quan hỗ trợ đăng ký và sẽ được đăng trên trang chủ của cục quản lý xuất nhập cảnh.',
rso_dec7: 'thời hạn đăng ký là 5 năm và cần gia hạn.',
rso_dec8: 'cơ quan hỗ trợ đăng ký cần phải tiến hành nộp các loại báo cáo cho bộ trưởng cục quản lý xuất nhập cảnh bất cứ lúc nào hoặc theo định kỳ.',
article1: 'Visa kỹ năng đặc định là gì?',
article1_dec1: 'với việc ban hành Luật kiểm soát xuất nhập cảnh sửa đổi vào ngày 8 tháng 12 năm 2018, tư cách lưu trú "kỹ năng đặc định" đã được thiết lập mới. Có hiệu lực vào tháng 4 năm 2019.',
article1_dec2: 'tình trạng cư trú mới "kỹ năng đặc định" sẽ được thiết lập trong 2 giai đoạn. (số 1, số 2)',
article1_dec3: 'đối tượng ngành nghề là 14 ngành.',
article1_dec4: 'yêu cầu của đối tượng người nước ngoài là những người có "kỹ năng đòi hỏi kiến thức hoặc kinh nghiệm đáng kể". Nói cách khác, đối tượng là những người đã hoàn thành 3 năm thực tập kỹ năng, hoặc những người đã đỗ kỳ thi tiếng Nhật và kỹ năng tương đương.',
article1_dec5: '"Kỹ năng đặc định số 1" được phép ở lại tối đa 5 năm với tư cách là một người có kỹ năng nhất định. Không cho phép bảo lãnh gia đình.',
article1_dec6: '"Kỹ năng đặc định số 2" được cấp tư cách lưu trú tương đương với lao động chung bằng cách vượt qua kỳ kiểm tra cấp chuyên ngành trong thời gian kỹ năng đặc định số 1, với tư cách là một người có kỹ năng lành nghề.(bằng cách gia hạn thời gian lưu trú, trên thực tế có thể vĩnh trú và cho phép bảo lãnh gia đình)',
article2: 'tin nhắn đại diện',
article2_sub1: 'đừng từ bỏ Nhật Bản',
article2_dec1: 'Từ tận đáy lòng, chúng tôi xin gửi lời cảm ơn chân thành đến thực tập sinh kỹ năng và những thực tập sinh đã về nước, đã đến Nhật Bản với tư cách thực tập sinh kỹ năng, đã học hỏi, tích lũy kỹ thuật, không tiếc công sức cho sự phát triển của quê hương, đất nước. Hình dáng những người lao động sẵn sàng làm mọi công việc vì gia đình, vì tổ quốc là tư thế vốn dĩ của con người, nhưng lại không còn được thấy ở Nhật Bản đương thời nữa. Trong một thời gian dài, tôi đã làm việc cho một dự án thực tập sinh kỹ năng, chỉ có visa thực tập sinh kỹ năng mới có thể nhập cảnh, tôi đã thấy rất nhiều bóng dáng tận dụng cơ hội đó, nghiêm túc thực tập tại Nhật Bản, khởi nghiệp tại quê hương và phát triển rất lớn mạnh. Tuy nhiên, "visa kỹ năng đặc định" được xây dựng vào tháng 4 năm 2019 để thực hiện mong muốn được trải nghiệm Nhật Bản khi không thể học đầy đủ trong số năm quy định.Tôi hy vọng rằng nhiều người nước ngoài đến thăm Nhật Bản, những người luôn giữ ngọn lửa khát vọng ẩn sâu trong đôi mắt, điều hiếm thấy ở Nhật Bản ngày nay, có thể cùng nhau phát triển Nhật Bản.Trên tất cả, tôi muốn hình thành một xã hội mà mọi người yêu thích đất nước Nhật Bản, gia tăng số lượng vĩnh trú và có thể sống chung với nhau.',
article2_dec2: 'công ty cổ phần Mieruka',
article2_dec3: 'chủ tịch và giám đốc điều hành',
article2_dec4: 'Horiuchi Kazuhiko',
article3: '3 đặc trưng AELU cung cấp',
article3_sub1: 'luyện thi trực tuyến',
article3_sub1_dec1: 'bắt đầu với câu hỏi trước đây "AELU" có thể thực hiện các biện pháp cho kỳ thi kiểm tra trình độ kỹ năng đặc định trên điện thoại thông minh, chúng tôi sẽ chuẩn bị các câu hỏi giả định của các nhà chuyên môn, sau 30 câu hỏi trong tất cả 14 ngành, bạn có thể thực hiện các biện pháp bao nhiêu lần tùy ý hướng đến ngày thi. Nếu trên số điểm quy định trong các câu hỏi được đưa ra bởi AI, bạn chắc chắn sẽ vượt qua kỳ thi!',
article3_sub2: 'thông tin kỳ thi',
article3_sub2_dec1: 'thông tin kỳ thi rất khó hiểu đối với người nước ngoài đến thăm Nhật Bản, sẽ được tự động bổ sung khi thông tin kỳ thi của ngành đã chọn được cập nhật sau khi đăng ký và sẽ được thông báo cho người dùng.',
article3_sub3: 'đại diện đăng ký dự thi',
article3_sub3_dec1: 'như thông tin về kỳ thi, rất khó khăn đối với người nước ngoài đến thăm Nhật Bản đăng ký dự thi, nếu không làm thủ tục trực tuyến thì không thể tham gia kỳ thi. Hệ thống sao chép thông tin tại thời điểm đăng ký, có sẵn đơn đăng ký, và có thể đăng ký đồng thời cùng lúc với công bố thi.',
article4: 'giới thiệu chức năng sau khi vượt qua bài kiểm tra',
article4_sub1: 'hoàn tiền mừng cho người đã thi đỗ (dù ở trong hay ngoài nước)',
article4_sub1_dec1: 'những người đã sống ở Nhật Bản, sử dụng AELU đã thi đỗ, và nếu đã tải lên giấy chứng nhận thi đỗ, số hiệu thi đỗ vào màn hình người dùng của bản thân, thì có thể nhận lại tiền ngay trong ngày hoàn tiền. Các sản phẩm dự định hoàn lại: phiếu quà trực tuyến (dạng thư điện tử phiếu quà tặng Amazon, Googleplay, thẻ quà tặng iTunes) tương đương 5000 yên sẽ được hoàn lại từ tài khoản chính thức của LINE',
article4_sub2: 'chiến dịch giới thiệu bạn bè',
article4_sub2_dec1: 'chúng tôi sẽ mời những người có nguyện vọng đi Nhật Bản cả trong và ngoài nước tham gia nhóm FB, người dùng thông báo số hiệu quản lý của bản thân, và hoàn tiền cho người liên kết với số hiệu đó, 1 tháng sau khi gia nhập thành viên, 1000 yên vé quà tặng trực tuyến sẽ được trao cho người giới thiệu.',
article4_sub3: 'sau khi nhận được visa, AI sẽ tự động kết hợp để tìm kiếm việc làm (chưa quyết định)',
article4_sub3_dec1: 'nếu bạn sử dụng AELU, sau khi đỗ kỳ thi kiểm tra trình độ, hãy tải số hiệu thi đỗ, giấy chứng nhận thi đỗ lên màn hình người dùng và bạn sẽ nhận được đề nghị tự động từ tất cả các công ty ở Nhật Bản. Các cuộc phỏng vấn cũng sẽ được tổ chức trực tuyến, ký hợp đồng trực tuyến với thư mời làm việc đã được nhận trước đó, an tâm nhập cảnh, chuyển nhà và bắt đầu công việc!',
article4_sub4: 'hoàn tiền khi kiểm tra thẻ cư trú định kỳ (chưa xác định)',
article4_sub4_dec1: 'trong ứng dụng kiểm tra thẻ cư trú "One check tab", nếu bạn kiểm tra thẻ cư trú mỗi tháng 1 lần, mà không qua AELU, thì sẽ được hoàn 10000 yên/năm.',
article5: 'giới thiệu chức năng cụ thể',
article5_sub1: 'có thể nhìn lại các câu hỏi đã giải',
article5_sub1_dec1: 'có thể tích lũy nội dung thi mà đã luyện trực tuyến và sử dụng các công cụ của riêng bạn để hiểu được thói quen của người dùng và khắc phục những vấn đề mà bạn chưa giỏi. Vì có thể thực hiện đối sách thi nhiều lần, ghi lại toàn bộ lịch sử điểm số và thời gian thi và có thể thực hiện càng gần ngày thi chính thức càng tốt. Ngoài ra, vì viết bằng ngôn ngữ của bạn và tiếng Nhật nên có thể hiểu câu hỏi tốt hơn.',
article5_sub2: 'lưu vĩnh viễn sơ yếu lý lịch tại thời điểm nhập cảnh',
article5_sub2_dec1: 'khi tham gia kỳ thi visa kỹ năng đặc định và xin visa, cần phải có bản sơ yếu lý lịch tại thời điểm nhập cảnh với tư cách thực tập sinh kỹ năng. Ban đầu, do quản lý đoàn thể (nghiệp đoàn) hoặc công ty phái cử lưu giữ, nhưng sau khi nhận được visa kỹ năng đặc định, mỗi người có thể tự mình lưu giữ.',
article5_sub3: 'tính năng đăng ký quốc gia và lĩnh vực của bạn',
article5_sub3_dec1: 'vì mô tả bằng cả tiếng Nhật và ngôn ngữ của đất nước bạn nên bạn có thể hiểu rõ các câu hỏi và đưa ra các biện pháp giải. Trong kỳ thi ban đầu chỉ có tiếng Nhật nên đối sách cũng có thể chỉ bằng tiếng Nhật.',
article5_sub4: 'nhắc lại các yêu cầu và thông tin kỳ thi kiểm tra trình độ',
article5_sub4_dec1: 'khi các tổ chức kiểm tra đăng tải lịch trình thi theo ngành nghề mong muốn lên trang chủ, nó sẽ tự động được nhắc nhở, người dùng sẽ được thông báo, ngày kiểm tra sẽ được thiết lập trên màn hình người dùng và đồng hồ hẹn giờ sẽ hoạt động tự động.',
article5_sub5: 'học bằng cách sử dụng sàng lọc',
article5_sub5_dec1: 'có thể lọc ra phần yếu điểm của người dùng và có thể thực hiện đối sách thi.',
article5_sub6: 'tư vấn học và trao đổi trực tuyến bằng cách sử dụng máy ảnh trên điện thoại thông minh',
article5_sub6_dec1: 'trong quá trình tiến hành đối sách kỳ thi kiểm tra trình độ bằng cách sử dụng AELU, có thể hiểu rõ ý nghĩa và ý đồ của các câu hỏi bằng cách gọi điện thoại trực tuyến hoặc bằng hình thức trò chuyện, nhắn tin. Có thể không cần thiết đối với những người đã quen và hiểu rõ Nhật Bản, nhưng dịch vụ tư vấn cuộc gọi cơ bản là cách an tâm nhất để xác nhận những điểm lo lắng trước kỳ thi!',
article6: 'tiền phí',
article6_sub1: 'phí sử dụng AELU',
article6_sub1_dec1: 'có thể học không giới hạn cho kỳ thi kiểm tra trình độ visa kỹ năng đặc định. Có thể trao đổi bằng ngôn ngữ mẹ đẻ qua điện thoại trực tuyến ※Có thể sử dụng như một thông dịch viên trong thời gian bình thường. Vào ngày thi, có thể thông báo đến hội trường thi. Sơ yếu lý lịch thời điểm nhập cảnh có thể được lưu mãi mãi. Sau khi đỗ kỳ thi, chỉ cần đăng ký số hiệu thi đỗ visa kỹ năng đặc định của bạn, chúng tôi sẽ giới thiệu cho bạn công việc mong muốn (chưa quyết định).',
article6_sub2: 'đại diện đăng ký thi',
article6_sub2_dec1: 'bạn không thể đăng ký trong quá trình làm việc, bạn sẽ không thể tham gia kỳ thi kiểm tra trình độ trừ khi bạn đăng ký, vì vậy chúng tôi sẽ đại diện đăng ký ngay tức thì khi có thông tin về kỳ thi kiểm tra trình độ để bạn không bị lỡ ngày thi.',
article7: 'Hiện đang thực hiện chiến dịch hoàn tiền!',
article7_dec1: 'trong số những người đã đỗ kỳ thi, không có ngoại lệ, hoàn lại 5000 yên với những người đã đăng ký số hiệu visa cho dịch vụ này. Bấm vào đây để biết chi tiết về cách tham gia chiến dịch.',
article8: 'Nào, chúng ta hãy cùng đăng ký AELU !',
dashboard: 'bảng điều khiển',
member_info: 'đăng ký thông tin cá nhân',
first_name: 'tên',
midle_name: 'tên đệm',
family_name: 'họ',
half_width_Roman: 'romaji cỡ chữ nhỏ',
password: 'mật khẩu',
password_confirm: 'mật khẩu (xác nhận)',
mail_adress: 'địa chỉ email',
lineId: 'LINE ID (bắt buộc trong trường hợp nhận dịch vụ cuộc gọi)',
country_id: 'mã quốc gia',
phone: 'số điện thoại',
issuing_country: 'chọn quốc gia/khu vực phát hành giấy tờ tùy thân',
IDtype: 'chọn loại ID',
residence_card: 'thẻ cư trú hoặc thẻ ID',
passport: 'hộ chiếu',
regist: 'đăng ký',
is_required: 'là bắt buộc',
sign_up: 'đăng ký mới',
residence_front: 'tải mặt trước lên',
residence_back: 'tải mặt sau lên',
passport_upload: 'tải hộ chiếu lên',
error_file: 'hãy tải ảnh lên',
post_resume: 'nộp sơ yếu lý lịch',
resume_upload: 'tải sơ yếu lý lịch lên',
click_upload: 'bấm để tải lên',
image_drop: 'hoặc kéo và thả tệp hình ảnh',
select_language: 'chọn ngôn ngữ mẹ đẻ',
vietnamese: 'tiếng Việt Nam',
chinese: 'tiếng Trung Quốc',
english: 'tiếng Anh',
khmer: 'tiếng Khmer',
indonesian: 'tiếng Indonesia',
tagalog: 'tiếng Tagalog',
burmese: 'tiếng Miến Điện',
hindu: 'tiếng Hindu',
lao: 'tiếng Lào',
mongolian: 'tiếng Mông Cổ',
bengali: 'tiếng Bengal',
sinhala: 'tiếng Sinhala',
banglodesh: 'tiếng Bangladesh',
malay: 'tiếng Mã Lai',
nepali: 'tiếng Nepal',
thai: 'tiếng Thái Lan',
japanese: 'tiếng Nhật Bản',
error_lang: 'Hãy chọn ngôn ngữ mẹ đẻ.',
select_ouccupation: 'lựa chọn ngành nghề',
select_max_three: 'có thể chọn tối đa 3',
industry_id_1: 'ngành hộ lý',
industry_id_2: 'ngành vệ sinh tòa nhà',
industry_id_3: 'ngành công nghiệp vật liệu',
industry_id_4: 'ngành công nghiệp cơ khí chế tạo máy',
industry_id_5: 'ngành công nghiệp liên quan đến thông tin điện và điện tử',
industry_id_6: 'ngành xây dựng',
industry_id_7: 'công nghiệp đóng tàu và thiết bị hàng hải',
industry_id_8: 'ngành bảo dưỡng ô tô',
industry_id_9: 'ngành hàng không',
industry_id_10: 'dịch vụ lưu trú',
industry_id_11: 'nông nghiệp',
industry_id_12: 'ngư nghiệp',
industry_id_13: 'sản xuất thực phẩm và đồ uống',
industry_id_14: 'ngành phục vụ ăn uống',
industry_id_15: "Raw Material, Industrial Machinery, and Electrical/Electronic Information-related Manufacturing Industry",
industry: 'ngành',
error_occupation: 'vui lòng chọn từ một ngành nghề trở lên',
do: 'làm',
news_tpic: 'tin tức',
days_until_exam: 'số ngày còn lại cho đến kỳ thi',
estimated_pass_rate: 'tỷ lệ đỗ ước tính',
average_score_taken: 'điểm trung bình của bài kiểm tra đã thi',
exam: 'kỳ thi là',
let_aim: 'hãy hướng tới',
score: 'điểm',
solve_problem: 'giải câu hỏi',
recommend_problem: 'câu hỏi được đề xuất của AELU',
solved_problem: 'câu hỏi đã được giải trước đây',
looking_solved: 'xem các câu hỏi trước đây>',
application_agency: 'dịch vụ đại diện đăng ký thi',
billing: 'thanh toán',
more_look: 'xem thêm>',
more_look2: 'xem thêm',
facebook: 'Facebook',
google: 'Google',
until_not_account: 'nếu bạn chưa có tài khoản,',
or: 'hoặc',
other_way: 'bằng cách khác,',
not_have_account: 'nếu bạn không có tài khoản,',
have_account: 'nếu bạn có tài khoản,',
forgot_password: 'nếu bạn quên mật khẩu,',
this: 'bên này',
at_login: 'đăng nhập bằng',
pass_condition: '8 hoặc nhiều hơn chữ-số có chiều rộng nhỏ, chữ cái in hoa, ký tự',
at_sign_up: 'đăng ký mới với',
agreement1: 'bằng cách đồng ý với những điều sau đây và chọn tiếp tục, AELU',
terms: 'điều khoản sử dụng dịch vụ',
agreement2: 'tôi đồng ý với',
agree: 'đồng ý và tiếp tục',
account_confirm: 'mã xác nhận',
confirm: 'xác nhận',
not_confirm: 'mã xác nhận chưa được xác nhận',
move_confiirm: 'chuyển đến màn hình nhập mã xác nhận',
top: 'đầu trang',
news_list: 'bảng tin',
problim_list: 'danh sách câu hỏi',
learning_consul: 'tư vấn rèn luyện',
agency: 'thông tin kỳ thi',
of_trend: 'về hướng đi của kỳ thi',
start_test: 'bắt đầu kiểm tra',
study_mode: 'chế độ luyện tập',
order_question: 'câu hỏi',
of_question: 'trong câu hỏi',
question_current: 'câu trả lời đúng',
to_mypage: 'đi đến trang cá nhân của tôi',
correct_answer: 'đáp án sai!',
correct_answer_normal: 'đáp án đúng',
no_correct_answer: 'đáp án sai',
next: 'đến câu hỏi tiếp theo',
finish_all: 'đã trả lời tất cả các câu hỏi!',
your_score: 'điểm số của bạn là',
is: 'là!',
result_description: 'có thể giải các câu hỏi khác từ mục "Xem danh sách câu hỏi". Cũng có thể xem lại các câu hỏi đã giải trước đây từ trang danh sách câu hỏi.',
back_quiz_list: 'xem danh sách câu hỏi>',
retry: 'giải câu hỏi này thêm 1 lần nữa>',
no_description: 'không có giải thích',
show_ans: 'xem câu trả lời',
of_solved_problem: 'câu hỏi đã được giải trước đây',
of_solved_problem_list: 'danh sách câu hỏi đã được giải trước đây',
solved_description: 'có thể xem lại bài kiểm tra rèn luyện để chuẩn bị cho kỳ thi visa kỹ năng đặc định của ngành hộ lý.',
before_result: 'kết quả trước đó',
looking_back: 'xem lại',
back_solved_problem_list: 'xem danh sách những câu hỏi đã được giải',
again_retry: 'xem lại câu hỏi này một lần nữa',
done_member_regist: 'cảm ơn bạn đã đăng ký thành viên!',
done_member_regist_description: 'mỗi dịch vụ có thể sử dụng sau khi đã thanh toán phí sử dụng dịch vụ. Vui lòng đăng ký thông tin thanh toán.',
choose_payment: 'chọn phương thức thanh toán',
service_content: 'nội dung dịch vụ',
test_info_service: 'dịch vụ cung cấp thông tin kỳ thi',
usage_fee: 'phí sử dụng',
test_fee: '500 yên+thuế',
application_fee: '20 000 yên+thuế',
method_payment: 'phương thức thanh toán',
LINE_pay: 'LINE Pay',
line_pay_description: '※Vui lòng lưu hình ảnh mã QR, thanh toán trong dịch vụ LINE Pay. Khi thanh toán bằng LINE Pay, sẽ mất thời gian để ban quản lý xác nhận.',
save_qr: 'lưu mã QR',
next_stage: 'tiếp theo',
credit_card: 'thẻ tín dụng',
copmplete_payment: 'thanh toán đã hoàn tất.',
copmplete_payment_descript: 'thanh toán đã hoàn tất, bạn có thể sử dụng tính năng luyện thi trực tuyến, thông tin kỳ thi, dịch vụ đại diện đăng ký thi.',
start_sevice: 'bắt đầu sử dụng dịch vụ',
to_payment: 'đến màn hình thanh toán',
of_news_list: 'bảng tin',
done_payment: 'thanh toán đã hoàn tất.',
tv_consult: 'tư vấn qua gọi video trực tuyến',
tell_consult: 'tư vấn qua điện thoại',
learning_consul_descript01: 'của đăng ký thi',
learning_consul_descript02: 'thực hiện thay thế',
money_unit: 'yên',
learning_consul_unit: '1 lần',
fault_payment1: 'thanh toán không thành công.',
fault_payment2: 'vui lòng thử lại.',
no_examination: 'vẫn chưa có',
no_exam: 'vẫn chưa có kỳ thi',
undecided: 'chưa quyết định',
retry_login: 'xin vui lòng đăng nhập lại',
no_problem: 'không có câu hỏi nào được giải',
do_problem: 'giải câu hỏi',
qa_title: 'các câu hỏi thường gặp',
search_category: 'lọc theo thể loại',
search_freeward: 'tìm kiếm bằng từ khóa tự do',
test_result: 'mô phỏng kết quả thi',
to_top: 'đến đầu trang',
missPassword: 'mật khẩu hoặc địa chỉ email không đúng',
sample_problem: 'hãy thử trải nghiệm luyện thi trực tuyến',
exercises: 'câu hỏi thực hành',
let_exercises: 'hãy thử giải một câu hỏi thực tế!',
to_qa: 'Xem thêm Q&A',
read_more: 'xem thêm',
account_setting: 'cài đặt tài khoản',
profile_setting: 'cài đặt trang cá nhân',
notification_setting: 'cài đặt thông báo',
logout: 'đăng xuất',
changeEmail: 'thay đổi địa chỉ email',
changePassword: 'thay đổi mật khẩu',
change: 'thay đổi',
save: 'lưu giữ',
change_success: 'đã thay đổi',
now_password: 'mật khẩu hiện tại',
new_password: 'mật khẩu mới',
check_new_password: 'mật khẩu mới (xác nhận)',
do_logout: 'đã đăng xuất',
done_learning_consul_payment: 'thanh toán đã được hoàn tất.',
past_exam: 'câu hỏi trước đây',
update_info: 'đang cập nhật thông tin mới nhất',
official_sns: 'SNS chính thức',
privacy_policy: 'chính sách bảo mật',
terms_service: 'điều khoản sử dụng',
transaction_law: 'biểu thị dựa trên luật giao dịch buôn bán đặc định',
selectCountry: 'hãy chọn quốc gia',
goInquiry: 'tiến đến liên hệ',
lineInquiry: 'liên hệ qua LINE',
regist_accept_certificate: 'lưu giấy chứng nhận thi đỗ đã đạt được visa kỹ năng đặc định',
accept_certificate_description: 'có thể lưu lại giấy chứng nhận thi đỗ và số hiệu',
accept_certificate: 'giấy chứng nhận thi đỗ',
accept_number: 'số hiệu trúng tuyển',
immigration_resume: 'lưu lại sơ yếu lý lịch thời điểm nhập cảnh',
resendCode: 'gửi lại mã xác minh',
line_at_register: 'liên hệ dịch vụ qua LINE@',
study: 'học- ôn lại',
study_text: 'tải xuống giáo trình rèn luyện',
do_resume_update: 'vui lòng tải lên bản sơ yếu lý lịch',
done_resume_update: 'Cảm ơn bạn đã đăng ký lưu bản sơ yếu lý lịch!',
regist_resume_enter: 'lưu bản sơ yếu lý lịch thời điểm nhập cảnh',
about_company: 'về công ty vận hành',
add_exam_info_detail: 'thông tin kỳ thi đã được thêm vào. Bấm vào đây để biết chi tiết và đăng ký',
regist_result_get_money: 'lưu kết quả thi và nhận tiền',
detail: 'chi tiết',
about_withdrawal_subsc: 'về việc rời khỏi hội nhóm và hủy đặt mua thanh toán định kỳ',
apply_withdrawal: 'đăng ký thủ tục rời khỏi hội nhóm',
apply_subsc: 'đăng ký hủy đặt mua thanh toán định kỳ',
about_withdrawal: 'đăng ký rời khỏi hội nhóm',
about_subsc: 'hủy đặt mua thanh toán định kỳ',
exam_info: 'thông tin kỳ thi',
date: 'thời gian',
day: 'ngày',
place: 'địa điểm',
result_publication: 'thông báo kết quả thi',
result_publication_place: 'địa điểm thông báo kết quả thi',
result_this_page: 'được thông báo trên trang này',
exam_way: 'hình thức thi',
exam_way2: 'dạng câu hỏi của bài thi',
include_exam_fee: 'bao gồm chi phí thi',
exam_application_desc: 'đại diện nộp đơn đăng ký dự thi \n trao đổi với văn phòng thi \n liên hệ về những thứ cần chuẩn bị trước ngày hôm đó (LINE@) \n trao đổi về những điều chưa rõ liên quan đến kỳ thi',
self_application: 'tự đăng ký',
application_method: 'phương thức đăng ký',
under_this_url: 'vui lòng hoàn tất thủ tục đăng ký từ URL dưới đây',
do_appliction: 'đăng ký thi',
study_with_aeru: 'Sử dụng tính năng luyện thi từ trang đầu để tăng tỷ lệ đỗ',
line_at_consul: 'Dịch vụ tư vấn học tập LINE @',
instagram: 'Instagram',
do_signup: 'đã được xác thực. Vui lòng đăng nhập lại',
gender: 'giới tính',
man: 'nam',
woman: 'nữ',
input_problem_title: 'có tiêu đề câu hỏi',
still_no_problem: 'không có câu hỏi',
enter_in_problem_trend: 'có giải thích về các bài thi đơn giản, như là xu hướng của các bài thi từ trước đến nay, hình thức trả lời câu hỏi (hình thức lựa chọn), v.v.',
correct: 'đáp án đúng',
explanation: 'giải thích',
problem: 'câu hỏi',
do_nursing_not_published: 'trong ngành hộ lý, kỳ thi vẫn được tổ chức, nhưng các đề thi trước đây chưa được công bố',
practical_exam_of_year: 'thi thực hành năm',
judgment_test_of_year: 'kỳ thi phán đoán 2019',
judgment_test_answer_of_year: 'đáp án kỳ thi phán đoán 2019',
not_yet_test_material: 'kỳ thi vẫn chưa được tổ chức với ngành công nghiệp vật liệu',
not_yet_test_machinery: 'kỳ thi vẫn chưa được tổ chức với ngành công nghiệp đóng tàu và thiết bị hàng hải',
not_yet_test_electronic: 'kỳ thi vẫn chưa được tổ chức với ngành công nghiệp liên quan đến thông tin điện và điện tử',
not_yet_test_construction: 'kỳ thi vẫn chưa được tổ chức với ngành xây dựng',
not_yet_test_shipbuilding: 'kỳ thi vẫn chưa được tổ chức với ngành công nghiệp đóng tàu và thiết bị hàng hải',
do_automobile_not_published: 'trong ngành bảo dưỡng ô tô, kỳ thi vẫn được tổ chức, nhưng các đề thi trước đây chưa được công bố',
do_aviation_not_published: 'trong ngành hàng không, kỳ thi vẫn được tổ chức, nhưng các đề thi trước đây chưa được công bố',
do_agricultural_not_published: 'trong ngành nông nghiệp, kỳ thi vẫn được tổ chức, nhưng các đề thi trước đây chưa được công bố',
do_fishery_not_published: 'trong ngành ngư nghiệp, kỳ thi vẫn được tổ chức, nhưng các đề thi trước đây chưa được công bố',
do_food_not_published: 'trong ngành sản xuất thực phẩm và đồ uống, kỳ thi vẫn được tổ chức, nhưng các đề thi trước đây chưa được công bố',
do_restaurant_not_published: 'trong ngành phục vụ ăn uống, kỳ thi vẫn được tổ chức, nhưng các đề thi trước đây chưa được công bố',
schedule_undecided: '(※kế hoạch chưa được quyết định)',
year: 'năm',
month: 'tháng',
texts_learning: 'giáo trình học tập các ngành',
texts_learning_test: 'giáo trình ôn thi đánh giá kỹ năng đặc định',
skill_test_sample: 'mẫu đánh giá kỳ thi kỹ năng',
japanese_test_sample: 'mẫu đánh giá kỳ thi tiếng Nhật',
not_building_texts: 'chưa có giáo trình ôn thi ngành vệ sinh tòa nhà',
not_material_texts: 'chưa có giáo trình ôn thi ngành công nghiệp vật liệu',
not_machinery_texts: 'chưa có giáo trình ôn thi ngành công nghiệp cơ khí chế tạo máy',
not_electronic_texts: 'chưa có giáo trình ôn thi ngành công nghiệp liên quan đến thông tin điện và điện tử',
not_shipbuilding_texts: 'chưa có giáo trình ôn thi ngành công nghiệp đóng tàu và thiết bị hàng hải',
not_automobile_texts: 'chưa có giáo trình ôn thi ngành bảo dưỡng ô tô',
not_accommodation_texts: 'chưa có giáo trình ôn thi ngành dịch vụ lưu trú',
not_food_texts: 'chưa có giáo trình ôn thi ngành sản xuất thực phẩm và đồ uống',
not_restaurant_texts: 'giáo trình ôn thi kỹ năng đo lường ngành phục vụ ăn uống',
each_depertment_texts: 'giáo trình ôn thi mỗi ngành',
skill_test_basic: 'giáo trình ôn thi đánh giá kỹ năng (kỹ thuật cơ bản)',
skill_test_safety: 'giáo trình ôn thi đánh giá kỹ năng (an toàn- chất lượng công việc)',
skill_test_aircraft: 'giáo trình ôn thi đánh giá kỹ năng (tổng quan về máy bay)',
texts_livestock: '[Giáo trình học trồng trọt chăn nuôi] bản tiếng Nhật',
texts_cultivated: '[Giáo trình học nông nghiệp trồng trọt] bản tiếng Nhật',
skill_test_fishery: 'kiểm tra kỹ năng đo lường ngư nghiệp (thủy sản)',
skill_test_general_fishery: 'kiểm tra kỹ năng đo lường ngư nghiệp (tổng quát ngành thủy sản)',
skill_test_safety_fishery: 'kiểm tra kỹ năng đo lường ngư nghiệp (an toàn thủy sản)',
skill_test_specialty_fishery: 'kiểm tra kỹ năng đo lường ngư nghiệp (liên quan đến lưới chuyên ngành thủy sản)',
skill_test_related_fishery: 'kiểm tra kỹ năng đo lường ngư nghiệp (liên quan đến đánh cá chuyên ngành thủy sản)',
skill_test_aquaculture: 'kiểm tra kỹ năng đo lường ngư nghiệp (ngành nuôi trồng thủy sản)',
skill_test_general_aquaculture: 'kiểm tra kỹ năng đo lường ngư nghiệp (tổng quát ngành nuôi trồng thủy sản- an toàn)',
skill_test_feeding_aquaculture: 'kiểm tra kỹ năng đo lường ngư nghiệp (liên quan đến nuôi trồng thủy sản cho ăn)',
skill_test_non_feeding_aquaculture: 'kiểm tra kỹ năng đo lường ngư nghiệp (liên quan đến nuôi trồng thủy sản không cho ăn)',
registration_skill_visa: 'đăng ký lưu giấy chứng nhận thi đỗ đã đạt được visa kỹ năng đặc định',
please_register_pdf_number: 'vui lòng đăng ký ảnh hoặc bản PDF của giấy chứng nhận thi đỗ đã đạt được visa kỹ năng đặc định và số hiệu thi đỗ được ghi trên giấy chứng nhận thi đỗ',
regist_and_get_cash_bag: 'nếu bạn đăng ký ngay bây giờ, bạn có thể được hoàn trả 5000 yen',
thank_you_regist_visa_pass: 'Cảm ơn bạn đã đăng ký lưu giấy chứng nhận đạt được visa kỹ năng đặc định!',
exam_info_detail: 'tổng quan thực hiện kiểm tra',
em_exam_detail_language: 'dự định ngôn ngữ địa phương',
em_exam_detail_method: 'thi lý thuyết, thi thực hành',
em_exam_detail_way: 'kiểm tra dựa trên máy tính (CBT), phương thức kiểm tra trên giấy hoặc phương thức kiểm tra công việc như sản xuất, v.v.',
em_exam_detail_section: '19 hạng mục kiểm tra (đúc, rèn, đúc khuôn, gia công cơ khí, gia công kim loại dập, gia công kim loại, kim loại tấm công xưởng, mạ, xử lý nhôm Anodic oxidation, đánh bóng, kiểm tra máy móc, bảo trì máy móc, lắp ráp thiết bị điện từ, lắp ráp thiết bị điện, sản xuất bảng mạch in, đúc nhựa, sơn, hàn, đóng gói công nghiệp)',
em_exam_detail_notify: 'gửi thông báo kết quả qua thư điện tử sau khi kiểm tra',
em_exam_detail_border: 'Thi lý thuyết: 65% trở lên  Thi thực hành: 60 điểm trở lên',
ss_exam_detail_language: 'tiếng Nhật',
ss_exam_detail_method: 'kỳ thi kỹ năng được thực hiện bằng cách kiểm tra thực hành và kiểm tra lý thuyết. Kỳ thi thực hành sẽ được tiến hành theo từng hạng mục công việc. Kỳ thi lý thuyết sẽ được tiến hành theo từng hạng mục công việc bằng phương thức kiểm tra trên giấy.',
ss_exam_detail_way: 'phương thức kiểm tra trên giấy, cách khác',
ss_exam_detail_section: 'lý thuyết- thực hành- kỹ năng: hàn, sơn, gia công kim loại, đánh bóng, gia công cơ khí, lắp ráp thiết bị điện',
ss_exam_detail_notify: '--',
ss_exam_detail_border: 'Thi lý thuyết: 60% trở lên  Thi thực hành: đánh giá dựa trên kết quả thực hành',
c_exam_detail_language: 'tiếng Nhật',
c_exam_detail_method: 'kỳ thi kỹ năng được tiến hành bằng bài thi thực hành và thi lý thuyết.',
c_exam_detail_way: 'kiểm tra dựa trên máy tính (CBT), kiểm tra thực hành là phương pháp được chỉ định bởi pháp nhân đăng ký',
c_exam_detail_section: '--',
c_exam_detail_notify: 'công bố trên trang chủ',
c_exam_detail_border: 'Thi lý thuyết: 65% trở lên Thi thực hành: đánh giá dựa trên kết quả thực hành',
cm_exam_detail_language: 'tiếng Nhật',
cm_exam_detail_method: 'kỳ thi kỹ năng được tiến hành bằng bài thi thực hành và thi lý thuyết.',
cm_exam_detail_way: 'thực hiện thi thực hành và thi lý thuyết thông qua kiểm tra dựa trên máy tính (CBT)',
cm_exam_detail_section: 'Môn thi lý thuyết: 1. kiến thức cơ bản về cấu trúc, chức năng và phương pháp xử lý, 2. kiến thức sơ cấp về kiểm tra, sửa chữa và điều chỉnh, 3. kiến thức cơ bản về cấu trúc, chức năng và cách xử lý của máy kiểm tra bảo trì, thiết bị đo lường và dụng cụ, 4. kiến thức cơ bản về tính chất và cách sử dụng của vật liệu, nhiên liệu và dầu mỡ. Môn thi thực hành: 1. công việc cơ bản đơn giản, 2. tháo rời, lắp ráp, kiểm tra và điều chỉnh đơn giản, 3. dễ dàng sửa chữa, 4. xử lý máy kiểm tra bảo trì đơn giản, dụng cụ đo lường và dụng cụ.',
cm_exam_detail_notify: '--',
cm_exam_detail_border: 'Thi lý thuyết: 65% trở lên   Thi thực hành: tổng số điểm đạt được 60% trở lên',
a_exam_detail_language: 'ngôn ngữ địa phương và tiếng Nhật',
a_exam_detail_way: 'kiểm tra dựa trên máy tính (CBT), phương thức kiểm tra trên giấy',
a_exam_detail_section: ' ① giáo dục tổng quát về canh tác nông nghiệp, an toàn vệ sinh, giống- đặc điểm cây trồng, môi trường canh tác (cơ sở, thiết bị, vật liệu, máy móc), phương pháp- quản lý canh tác, diệt sâu bệnh-cỏ dại, thu hoạch, điều chỉnh, bảo quản, vận chuyển. ② thực hành quan sát đất, xử lý phân bón- hóa chất nông nghiệp, xử lý hạt giống, quản lý môi trường, xử lý vật tư- thiết bị- máy móc, công việc liên quan đến trồng trọt, an toàn vệ sinh. ③ nghe nội dung công việc nông nghiệp được chỉ định, v.v. bằng tiếng Nhật',
a_exam_detail_notify: 'công bố trên trang chính',
a_exam_detail_border: 'vượt qua điểm tiêu chuẩn đánh giá được quy định bởi Hội đồng nông nghiệp quốc gia đặt ra đối với tổng số điểm',
avi_exam_detail_method: 'kỳ thi kỹ năng được tiến hành bằng bài thi thực hành và thi lý thuyết.',
avi_exam_detail_section: 'Các câu hỏi sẽ được đưa ra từ tài liệu tham khảo được đăng tải trên trang chủ của Hiệp hội kỹ thuật hàng không Nhật Bản chuyên ngành. Kết luận thực hành, đo lường điện',
avi_exam_detail_notify: '--',
avi_exam_detail_border: 'Thi lý thuyết: 65% trở lên  Thi thực hành: tổng số điểm đạt được 65% trở lên',
f_exam_detail_language: 'tiếng nhật',
f_exam_detail_method: 'kỳ thi kỹ năng được tiến hành bằng bài thi thực hành và thi lý thuyết.',
f_exam_detail_way: 'Thực hiện các bài kiểm tra lý thuyết và thực hành thông qua kiểm tra dựa trên máy tính (CBT)',
f_exam_detail_section: 'Liên quan đến một số nghiệp vụ nhất định trong ngành ngư nghiệp (ngư nghiệp) hoặc thủy sản (nuôi trồng thủy sản), các môn thi phải xác nhận rằng các hướng dẫn của người giám sát có thể hiểu và thực hiện nó một cách chính xác hoặc thực hiện nó theo phán đoán của riêng họ và không chỉ đơn thuần đánh giá có hay không kiến thức chuyên môn, mà còn đánh giá có hay không năng lực phán đoán cần thiết, chính xác và kiến thức liên quan đến công việc trong ngành ngư nghiệp (ngư nghiệp) hoặc thủy sản (nuôi trồng thủy sản)',
f_exam_detail_notify: 'công bố trên trang chủ',
f_exam_detail_border: 'Những người có tổng số điểm của bài thi viết và bài thi kỹ năng thực hành vượt điểm chuẩn đánh giá do cơ quan tiến hành thi kỹ năng quy định thì được chấp nhận',
no_exam_info: 'thông tin khái quát kỳ thi vẫn chưa được công bố',
language: 'ngôn ngữ thực hiện',
method: 'phương pháp thực hiện',
way: 'phương thức thực hiện',
section: 'phân loại kỳ thi',
notify: 'thông báo kết quả kiểm tra',
border: 'tiêu chí kết quả kiểm tra',
go_line_at: 'đến line @',
thank_you_and_deactivate: 'Cảm ơn bạn đã sử dụng dịch vụ của chúng tôi. Về thủ tục thoát khỏi hội nhóm, vui lòng nhập thủ tục thoát khỏi hội nhóm từ kênh liên lạc LINE@ dưới đây. Về việc hủy thanh toán định kỳ, vui lòng nhập hủy thanh toán định kỳ từ kênh liên lạc LINE@ dưới đây. Chúng tôi sẽ tiến hành thủ tục ngay khi có xác nhận',
thank_you_and_subscribe: 'Cảm ơn bạn đã sử dụng dịch vụ của chúng tôi. \n về việc hủy thanh toán định kỳ, vui lòng nhập hủy thanh toán định kỳ từ kênh liên lạc LINE@ dưới đây. \n chúng tôi sẽ tiến hành thủ tục hủy hợp đồng ngay khi nhận được xác nhận',
ten_thousand_yen: 'vạn yên',
yen_per_month: 'yên/tháng',
how_to_use_this_service: 'quá trình sử dụng',
selecting_a_browser: 'lựa chọn trình duyệt',
selecting_a_browser_dec: 'Truy cập https://aelu.co.jp bằng trình duyệt web (Google chrome, Safari, edge, v.v.) * Không có ứng dụng',
provisional_registration: 'đăng ký tạm thời',
provisional_registration_dec: 'Đăng nhập bằng Facebook, ID Google hoặc đăng ký bằng địa chỉ email của bạn. Sau khi chọn ngôn ngữ mong muốn và nghề nghiệp mong muốn thì có thể xem nội dung mô phỏng kỳ thi kiểm tra trình độ trực tuyến.',
full_registration: 'đăng ký chính',
full_registration_dec: 'nhấp vào "Đăng ký chính thức" trên trang nội dung thi thử trực tuyến, điền các thông tin cần thiết, có thể sử dụng tất cả các dịch vụ bắt đầu từ câu hỏi mô phỏng của kỳ thi kiểm tra trình độ 14 ngành nghề.',
name_validate_message: 'vui lòng nhập thông tin giống với cách viết trong hộ chiếu',
live_at_area: 'nơi sống hiện tại',
agency_application: 'đại diện đăng ký thi',
mypage: 'trang cá nhân của tôi',
myanmar: 'tiếng Miến Điện',
exam_list: 'danh sách lịch thi',
no: 'thứ',
times: 'lần',
application_start: 'bắt đầu đăng ký',
application_end: 'đã hết thời hạn đăng ký',
enforcement: 'tiến hành',
applicated: 'đăng ký hoàn tất',
reception_time: 'thời gian tiếp nhận',
announthment_d: 'ngày công bố kết quả thi',
reception_period: 'thời hạn đăng ký',
detail_link: 'xem chi tiết',
exam_country: 'nước đăng cai',
line: 'LINE',
vietnum: 'Việt Nam',
laos: 'Lào',
malaysia: 'Malaysia',
bangladesh: 'Bangladesh',
indo: 'Ấn Độ',
nepal: 'Nepal',
mongol: 'Mông Cổ',
indonesia: 'Indonesia',
th: 'Thái Lan',
philipine: 'Philippines',
my: 'Myanmar',
uzbekistan: 'Uzbekistan',
pakistan: 'Pakistan',
japan: 'Nhật Bản',
news_title: 'tin tức liên quan đến visa kỹ năng đặc định',
missNowPassword: 'mật khẩu hiện tại không đúng',
article6_sub2_dec2: 'Nếu đăng ký tại đây, chúng tôi cũng sẽ thông báo tất cả các thông tin từ đăng ký thi cho đến lệ phí thi và hội trường cho đến ngày thi.',
create_naw_password: 'đổi mật khẩu',
send_confirmcode: 'mã xác nhận đã được gửi',
edit: 'thay đổi',
success_new_password_setting: 'mật khẩu mới đã được cài đặt.',
error_email: 'địa chỉ email chưa được đăng ký.',

click_here_businesses: "Bấm vào đây cho các doanh nghiệp",
regist_organization_staff_info: "Đăng ký thông tin doanh nghiệp / người dùng",
organization_info: "Thông tin kinh doanh",
staff_info: "Thông tin người dùng",
org_name: "Tên doanh nghiệp",
url: "URL",
org_scale: "tỉ lệ",
org_zip: "mã bưu điện",
org_adress1: "Các tỉnh",
org_adress2: "Thành phố",
org_adress3: "Địa chỉ / Tên căn hộ",
org_industry: "Ngành công nghiệp",
org_category: "thể loại",
org_description: "Sự miêu tả",
org_established_at: "Năm thành lập",
org_phone: "Số điện thoại doanh nghiệp",
failed_established_at: "Ngày không hợp lệ.",
staff_name: "tên tài khoản",
form_miss: "Có một sai lầm trong biểu mẫu đầu vào.",
back_joboffer_detail: "Quay lại chi tiết công việc <",
create_joboffer: "Tạo một công việc",
edit_joboffer: "Chỉnh sửa công việc",
stop_posting: "Ngừng đăng",
delete: "xóa bỏ",
job_title: "Chức vụ",
job_catch_phrase: "Cụm từ công việc",
job_category: "Loại nghề nghiệp",
employed_company_name: "Tên công ty tuyển dụng",
work_location: "Trụ sở làm việc",
employment_status: "Tình trạng việc làm",
full_time_employee: "Nhân viên toàn thời gian",
part_time_job: "công việc bán thời gian",
temporary_staff: "Cử lao động",
contract_employee: "Nhân viên hợp đồng",
intern: "Thực tập sinh",
subcontracting: "Thầu phụ",
contract: "Hợp đồng",
new_graduate: "Sinh viên mới tốt nghiệp",
salary: "Tiền lương",
annual_income: "Thu nhập hàng năm",
monthly_salary: "Tiền lương hàng tháng",
weekly_salary: "Lương hàng tuần",
dayly_salary: "Lương hàng ngày",
job_offer_attension1: "Cần nêu rõ các điều kiện lao động theo quy định, v.v ... đối với nội dung công việc theo quy định của pháp luật.",
job_offer_attension2: "Vui lòng kiểm tra các điều kiện làm việc, v.v ... được pháp luật quy định rõ ràng, sau đó mô tả nội dung công việc. (Tham khảo: Bộ Y tế, Lao động và Phúc lợi, Cục Lao động tỉnh &quot;Gửi đến tất cả các công ty tuyển dụng lao động&quot;)",
job_offer_attension3: "Việc làm có thể không được đăng nếu bạn sử dụng ngôn ngữ giới hạn độ tuổi, giới tính hoặc địa vị xã hội của người mục tiêu.",
job_offer_attension4: "Các ví dụ thường xuyên chưa được xuất bản: &quot;Chào mừng đến với tuổi 20&quot; &quot;Chào mừng đến với những người trẻ tuổi (những người trẻ tuổi)&quot; &quot;Chào mừng / giới hạn phụ nữ&quot; &quot;Chỉ dành cho sinh viên&quot;",
work_content_appeal: "Nội dung công việc và điểm hấp dẫn",
work_content_appeal_desc: "Người tìm việc sẽ dễ quan tâm hơn nếu bạn cho họ biết những điểm hấp dẫn trước.",
human_resources_seek: "Nguồn nhân lực",
human_resources_seek_desc: "Hãy truyền đạt không chỉ các kỹ năng bạn đang tìm kiếm mà còn cả thông tin cho phép người tìm việc hình dung về nơi làm việc.",
working_hours: "Giờ làm việc",
traffic_access: "Truy cập giao thông",
traffic_access_desc: "Ngoài thông tin về giao thông công cộng, hãy bao gồm thông tin như đi làm bằng ô tô và có bãi đậu xe cho nhân viên hay không.",
required: "Bắt buộc",
optional: "Bất kì",
other: "Khác",
photo: "ảnh",
upload_video: "Tải đoạn phim lên",
job_tag: "Thẻ công việc",
until_select_three: "Có thể chọn tối đa 3",
senior_support: "Hỗ trợ cấp cao",
salary_increase_promotion: "Có tăng lương / thăng chức",
no_overtime: "Không làm thêm giờ",
target_hiring_time: "Mục tiêu thời gian tuyển dụng",
additional_questions: "Câu hỏi thêm",
job_offer_title: "Tên công việc",
public: "Giải phóng",
private: "riêng tư",
public_status: "Tình trạng công khai",
occupation: "Nghề nghiệp",
walfare: "Đãi ngộ / phúc lợi",
create: "tạo nên",
hour: "Thời gian",
back_mypage: "Quay lại trang của tôi <",
job_offers: "Danh sách công việc",
look_matches: "Xem danh sách đối sánh",
now_public: "Bây giờ mở",
now_private: "Riêng tư",
check: "Xác nhận",
edit2: "Chỉnh sửa",
news_detail: "Chi tiết tin tức",
prefectures: "Các tỉnh",
hokkaido: "Hokkaido",
aomori: "Aomori",
iwate: "Iwate",
miyagi: "Miyagi",
akita: "Akita",
yamagata: "Yamagata",
fukushima: "Fukushima",
ibaraki: "Ibaraki",
tochigi: "Tochigi",
gunma: "Gunma",
saitama: "Saitama",
chiba: "Chiba",
tokyo: "Tokyo",
kanagawa: "Kanagawa",
niigata: "Niigata",
toyama: "Toyama",
ishikawa: "Ishikawa",
fukui: "Fukui",
yamanashi: "Yamanashi",
nagano: "Nagano",
gifu: "Gifu",
shizuoka: "Shizuoka",
aichi: "Aichi",
mie: "Gấp ba",
shiga: "Shiga",
kyoto: "Kyoto",
osaka: "Osaka",
hyogo: "Hyogo",
nara: "Nara",
wakayama: "Wakayama",
tottori: "Tottori",
shimane: "Shimane",
okayama: "Okayama",
hiroshima: "Hiroshima",
yamaguti: "Yamaguchi",
tokushima: "Tokushima",
kagawa: "Kagawa",
echime: "Ehime",
kochi: "Kochi",
fukuoka: "Fukuoka",
saga: "Saga",
nagasaki: "Nagasaki",
kumamoto: "Kumamoto",
oita: "Oita",
miyazaki: "Miyazaki",
kagoshima: "Kagoshima",
okinawa: "Okinawa",
sinhalese: "Sinhala",
exam_region: "Các tỉnh",
exam_place_list: "Danh sách địa điểm",
exam_place_name: "Tên địa điểm thi",
care_evaluation_test: "Bài kiểm tra đánh giá đào tạo kỹ năng chăm sóc dài hạn",
clean_building_test: "Những vấn đề trong quá khứ của ngành công nghiệp làm sạch",
answer: "câu trả lời",
skill_test_measurement: "Kiểm tra kỹ năng đo lường",
exam_problem: "câu hỏi của kỳ thi",
fields: "Ruộng và rau",
gardening: "Cơ sở làm vườn",
mushroom: "nấm",
fruit: "Cây ăn quả",
dairy: "sản phẩm bơ sữa",
poultry: "Chăn nuôi gia cầm",
pig: "Chăn nuôi lợn",
beginner: "Người bắt đầu",
professional: "Lớp chuyên nghiệp",
advanced: "Nâng cao",
technical_training_test: "Kiểm tra đánh giá đào tạo thực tập sinh kỹ thuật",
exam_part: "Một phần của đề thi",
tokoha_fruit: "Cây ăn quả Tokoha",
deciduous_fruit: "Cây ăn quả rụng lá",
ver: "Phiên bản",
errata: "errata",
form_work: "Xây dựng ván khuôn",
construction: "Thợ thạch cao",
tunnel_line: "Đường hầm đẩy",
earth_work: "Công việc làm đất",
loofing: "Lợp mái",
elecommunication: "viễn thông",
reinforcing_contstruction: "Kết cấu thanh gia cố",
reinforcing_joint: "Gia cố thanh khớp",
wall_painting: "Sơn (phủ tường)",
board_finish: "Kết thúc bảng, hoàn thiện nội thất",
steeplejack: "Nhảy",
spray_insulation: "Cách nhiệt urethane phun",
marine_civil: "Công trình dân dụng hàng hải",
concrete_pumping: "Bơm bê tông",
construction_machinery: "Xây dựng máy móc xây dựng",
learning_text: "Học văn bản",
basic_aircraft: "Máy bay kết luận công nghệ cơ bản, đo lường điện",
worksafety_quality: "An toàn lao động, chất lượng",
aircraft_overview: "Tổng quan về máy bay",
fish_general: "Thủy sản nói chung",
fish_safety: "An toàn thủy sản",
network_relations: "Quan hệ dây đặc sản thủy sản",
fish_relations: "Liên quan đến đánh bắt cá đặc sản",
aquaculture_general: "Nuôi trồng thủy sản nói chung",
feeding_aquaculture: "Đặc sản nuôi trồng thủy sản Nuôi trồng thủy sản",
unfed_aquaculture: "Đặc sản nuôi trồng thủy sản Nuôi trồng thủy sản không gia công",
attachment: "Tập tin đính kèm",
glossary: "Bảng chú giải",
feneral_customer: "Dịch vụ khách hàng chung",
food_dring_cooking: "Nấu ăn thức uống",
hygiene_management: "quản lý vệ sinh",
visa_application: "Đơn xin thị thực kỹ năng cụ thể",
certificate_residence_tax: "1. Giấy chứng nhận thuế cư trú (cho năm cuối cùng)",
salary_income_withholding : "2. Bản sao phiếu khấu trừ thu nhập tiền lương",
national_health_insured: "3. Bản sao thẻ Bảo hiểm y tế quốc dân của người được bảo hiểm y tế (nếu người đó đang tham gia)",
national_health_payment: "4. Giấy chứng nhận thanh toán phí bảo hiểm y tế quốc gia",
national_health_receipt: "5. Bản sao biên lai đóng phí Bảo hiểm Y tế Quốc gia",
technical_intern_training2: "6. Văn bản xác nhận đã hoàn thành tốt khóa đào tạo thực tập sinh kỹ năng số 2",
need_the_following : "Bạn cần một trong những thứ sau:",
pass_certificate_test_specialized : "・ Bản sao giấy chứng nhận đạt yêu cầu kỹ năng thực hành kỳ kiểm tra đánh giá kỹ năng (hạng chuyên ngành)",
technical_intern_training3: "・ Bản sao giấy chứng nhận đạt kỳ thi sát hạch kỹ năng nghề (lớp 3)",
evaluation_record_technical_intern: "・ Nếu không đạt kỳ thi trên, bạn cần điền vào biên bản đánh giá thực tập sinh kỹ năng.",
cartificate_pass_basic_test: "Để thay thế cho 7.6, bạn có thể nộp bản sao giấy chứng nhận vượt qua kỳ thi cơ bản tiếng Nhật Foundation của Nhật Bản hoặc bản sao giấy chứng nhận đạt kỳ thi năng lực Nhật ngữ (N4) trở lên.",
change_permission_application: "8. Chụp đơn xin phép thay đổi (dọc 4 cm x ngang 3 cm)",
resume_data_time_entry: "9. Tiếp tục dữ liệu tại thời điểm nhập cảnh",
select_file: "Chọn tệp tin",

description_movie: "Video giải thích",
how_to_use_movie: "Cách sử dụng video",
movie_news: "1. Tin tức về thị thực kỹ năng cụ thể",
movie_exam: "2. Số ngày còn lại cho đến ngày thi",
movie_predict_pass: "3. Tỷ lệ vượt qua ước tính",
movie_ave_study_test: "4. Điểm trung bình của bài kiểm tra bạn đã học",
movie_similar_exam: "5. Đề thi tương tự",
movie_learning_text: "6. Download giáo trình (SGK) học tập",
movie_solved_exam: "7. Các vấn đề tôi đã giải quyết trong quá khứ",
movie_pased_exam: "8. Về việc nhìn thấy những vấn đề trong quá khứ đã thực sự xuất hiện",
movie_resume_regist: "9. Tiếp tục đăng ký tại thời điểm nhập cảnh",
movie_pass_document_regist: "10. Đăng ký vượt qua bài kiểm tra trình độ",
movie_agency_service: "11. Dịch vụ đại lý đăng ký dự thi",
movie_consule_service: "12. Dịch vụ tư vấn học tập",
description_movie_trans: "Nếu bạn muốn xem bằng ngôn ngữ không phải tiếng Nhật, hãy nhấp vào dấu bánh răng, nhấp vào phụ đề và dịch tự động, chọn ngôn ngữ mẹ đẻ của bạn, sau đó xem.",
cultivated_agriculture_general: "Toàn bộ ngành trồng trọt",
"livestock_agriculture": "Nông nghiệp chăn nuôi",
"介護": "Chăm sóc điều dưỡng",
"ビルクリーニング": "Vệ sinh tòa nhà",
"建設": "Xây dựng",
"自動車整備": "Bảo dưỡng ô tô",
"航空業": "Ngành công nghiệp hàng không",
"農業": "Nông nghiệp",
"漁業": "Ngư nghiệp",
"飲食料品製造業": "Ngành sản xuất thực phẩm và đồ uống",
"外食業": "Ngành phục vụ ăn uống",
"型枠施工": "Lắp cốp pha panel",
"左官": "Trát vữa",
"コンクリート圧送": "Bơm bê tông",
"トンネル推進工": "Thi công đường hầm",
"建設機械施工": "Thi công bằng máy xây dựng",
"大工": "Thợ xây",
"屋根ふき": "Lợp mái nhà",
"電気通信": "Viễn thông",
"鉄筋施工": "Thi công cốt thép",
"鉄筋継手": "Mối nối cốt thép",
"壁装（壁張り）": "Sơn (lớp phủ tường)",
"ボード仕上げ、内装仕上げ": "Xử lý hoàn thiện thạch cao, hoàn thiện nội thất",
"とび": "Lắp giàn giáo xây dựng",
"吹き付けウレタン断熱": "Phun cách nhiệt urethanen",
"海洋土木工": "Thi công công trình hàng hải",
"航空機の基本技術 締結、電気計測": "Kỹ thuật cơ bản của máy bay bắt-siết, đo điện",
"作業安全、品質": "An toàn lao động, chất lượng",
"航空機概要": "Tổng quan về máy bay",
"耕種農業全般": "Toàn bộ ngành trồng trọt",
"畜産農業": "Nông nghiệp chăn nuôi",
"漁業一般": "Thủy sản nói chung",
"漁業安全": "An toàn thủy sản",
"漁業専門 綱関係": "Thủy sản chuyên ngành liên quan đến đánh bắt bằng lưới",
"漁業専門 釣り関係": "Thủy sản chuyên ngành liên quan đến câu cá",
"養殖業一般": "Nuôi trồng thủy sản nói chung",
"養殖業専門 給餌養殖関係": "Nuôi trồng thủy sản chuyên ngành liên quan đến nuôi trồng thủy sản có cấp mồi",
"養殖業専門 無給餌養殖関係": "Nuôi trồng thủy sản chuyên ngành liên quan đến nuôi trồng thủy sản không cấp mồi",
"接客全般": "Toàn bộ dịch vụ khách hàng",
"飲食物調理": "Chế biến đồ ăn thức uống",
"衛生管理": "Quản lý vệ sinh",
"日本語版": "Bản tiếng Nhật",
"英語版": "Bản tiếng Anh",
"クメール語版": "Bản tiếng Khmer",
"インドネシア語版": "Bản tiếng Indonesia",
"インドネシア語・正誤表": "Tiếng Indonesia - bản đính chính",
"ネパール語版": "Bản tiếng Nepal",
"モンゴル語版": "Bản tiếng Mông Cổ",
"ビルマ語版": "Bản tiếng Miến Điện",
"ベトナム語版": "Bản tiếng Việt Nam",
"タイ語版": "Bản tiếng Thái Lan",
"テキスト１": "Văn bản 1",
"テキスト２": "Văn bản 2",
"テキスト３": "Văn bản 3",
"テキスト４": "Văn bản 4",
"テキスト５": "Văn bản 5",
"ミャンマー(ビルマ)語版": "Bản tiếng Myanmar (Miến Điện)",
"カンボジア(クメール)語版": "Bản tiếng Campuchia (Khmer)",
"ミャンマー語版": "Bản tiếng Myanmar",
"中国語版": "Bản tiếng Trung Quốc",
"付属資料": "Tài liệu đính kèm",
"用語集": "Bảng chú giải",

invitation_code: "Mã mời",
exam_calender: "Lịch trình thi",
move_exam_detail: "Bạn có muốn chuyển sang trang chi tiết lịch trình thi không?",
move: "Di chuyển",
plece_select_language: "Vui lòng chọn ngôn ngữ",
select: "lựa chọn",
midle_category: "Nghề nghiệp",
select_industry_description: "Khi bắt đầu AELU chỉ có thể chọn tối đa 3 ngành, vì vậy hãy chọn ngành nghề bạn muốn làm việc. Nếu không có vấn đề gì thì hãy nhấn nút tiếp theo",
done_member_regist_description_2: "Từ bây giờ, AELU cũng sẽ hỗ trợ, chuẩn bị nhiều biện pháp cho kỳ thi kiểm tra trình độ, hướng đến việc lấy visa kỹ năng đặc định.",
done_member_regist_2: "Đăng ký thành viên đã hoàn tất.",
is_exist_user: "Người dùng có cùng địa chỉ email đã tồn tại.",
invitation_code_description: "(Hãy nhập mã mời từ cơ quan (tổ chức) xuất khẩu lao động, trường tiếng Nhật, nếu không nhập thì màn hình thanh toán chi phí sẽ hiện ra nên đừng quên nhập mã đó)",
pleace_select_region: "Vui lòng chọn tỉnh thành tổ chức",
pleace_add_messenger: "Tất cả các địa chỉ liên hệ sẽ được gửi qua Facebook messager nên hãy nhớ bổ sung thêm nhé",
add_messenger_bot: "Nhận thông báo",
visa_application_description: "Nơi lưu trữ các giấy tờ cần thiết khi xin visa kỹ năng đặc định",
check_agree: "Hãy đồng ý",
sample_title: "Đây là một tiêu đề giả. Vui lòng đặt",
sample_description: "Đây là một mô tả giả. Vui lòng đặt. Đây là một mô tả giả. Vui lòng đặt. Đây là một mô tả giả. Vui lòng đặt. Đây là một mô tả giả. Vui lòng đặt. Đây là một mô tả giả. Vui lòng đặt. Đây là một mô tả giả. Vui lòng đặt. Đây là một mô tả giả. Vui lòng đặt.",
create_profile_error: "Có sự nhầm lẫn trong việc nhập. Vui lòng kiểm tra các mục",
setting_confirm: "Vui lòng xác nhận nội dung đã nhập và đăng ký",
exam_learning: "Bài tập kiểm tra",
recommend_problem_solve: "Giải các câu hỏi thi tương tự",
of: "của",
see_solved_problem: "Giải các câu hỏi bạn đã giải \n trước đây",
past_exam_collection: "Câu hỏi thi \n đã xuất hiệntrước đây",
any_application_registration: "Lưu các loại đăng ký",
mypage_visa_application: "Xin \n visa kỹ năng đặc định",
applyt_exam_and_agent: "Đăng ký dịch vụ đại diện \n đăng ký thi",
myapge_regist_accept_certificate: "Đăng ký giấy chứng nhận thi đỗ \n kỳ thi kiểm tra kỹ năng",
mypage_consultaion_service: "Dịch vụ \n tư vấn học tập",
consultaion_service: "Dịch vụ tư vấn học tập",
consult: "Tham khảo ý kiến",
of_exam_day: "Ngày kiểm tra của",
your_ave_score: "Điểm trung bình bài kiểm tra \n của bạn",
your_estimated_pass_rate: "Tỷ lệ đỗ ước tính \n của bạn",
your_ave_score_fotter: "Điểm trung bình bài kiểm tra của bạn",
your_estimated_pass_rate_fotter: "Tỷ lệ đỗ ước tính",
mypage_study_text: "Tải về \n sách giáo khoa học tập",
exam_schedule: "Lịch trình thi",
resident_caption_title: "● Về việc tải lên thẻ cư trú hoặc thẻ ID",
resident_caption: "Hãy tải lên thẻ cư trú hoặc thẻ ID có thể xác nhận thông tin trong khung đỏ. Hãy tải lên thẻ ID hợp lệ hoặc thẻ cư trú chưa hết hạn \n. Hãy tải lên hình ảnh màu theo định dạng PDF \n hoặc JPG.",
password_caption_title: "● Về việc tải lên mật khẩu",
password_caption: "Hãy tải ảnh hộ chiếu có thể xác nhận được tên, ảnh, mã số riêng, ngày tháng năm sinh, quốc tịch và thời hạn hiệu lực \n như trong khung đỏ. Hãy tải ảnh hộ chiếu có hiệu lực, chưa hết hạn \n. Hãy tải ảnh màu theo định dạng PDF \n hoặc JPG.",
title_help: "Hỗ trợ",
step3_title_help: "Hãy nhập thông tin của bạn chính xác.",
lineid_input_help: "Mở LINE → Trang chủ → Cài đặt → Trang cá nhân → Kéo xuống sẽ hiện ra ID. Vui lòng nhập ID đó. Nếu bạn chưa tạo, vui lòng tạo và nhập vào.",
country_input_help: "Chọn quốc tịch của bạn.",
area_input_help: "Chọn quốc gia trong khu vực mà bạn đang sinh sống.",
phone_input_help: "Vui lòng điền số điện thoại của bạn.",
issuing_input_help: "Chọn khu vực đã phát hành giấy tờ tùy thân.",
idtype_input_help: "Chọn loại ID. Hãy chụp ngay ngắn bức ảnh đã chọn và tải lên. Vui lòng chụp ảnh thẳng để không có chỗ nào bị cắt xéo.",
invitation_input_help: "Hãy nhập mã mời nếu có.",
exam_menu_help: "Sẽ xuất hiện những câu hỏi tương tự với câu hỏi đã ra thực tế trước đây. Hãy giải đi giải lại các câu hỏi và chuẩn bị cho kỳ thi.",
past_menu_help: "Sẽ xuất hiện những câu hỏi mà bạn đã giải trước đây. Hãy ôn tập lại những câu hỏi mà bạn đã giải sai,...",
pastexam_menu_help: "Giáo trình về các đề thi đã ra thực tế trước đây.",
text_menu_help: "Bạn có thể xem sách giáo khoa học tập để xem những điều quan trọng và tìm hiểu những vấn đề bạn chưa hiểu.",
visa_menu_help: "Chúng tôi sẽ giúp bạn lấy visa kỹ năng đặc định. Nếu muốn lấy visa kỹ năng đặc định thì hãy đăng ký từ đây.",
agency_menu_help: "Chúng tôi sẽ đại diện đăng ký đăng ký kỳ thi kỹ năng đặc định. Nếu bạn muốn tham gia kỳ thi kỹ năng đặc định thì hãy đăng ký từ đây.",
cer_menu_help: "Những người đã tham gia kỳ thi kỹ năng đặc định và có giấy chứng nhận thi đỗ thì hãy đăng ký từ đây.",
service_menu_help: "Nếu bạn có bất kỳ câu hỏi hoặc thắc mắc nào, vui lòng liên hệ với chúng tôi qua khung chat từ đây.",
occu_title_help: "Vui lòng chọn tối đa 3 ngành nghề mong muốn.",
back: "trở lại",
before: "Đối với vấn đề trước",
srilank: "Sri Lanka",
reselect: "Nếu bạn muốn thay đổi tệp, hãy nhấn lại &quot;Tải lên hộ chiếu của bạn&quot; và chọn lại",
iphone_file: "Đối với iphone, vui lòng sử dụng sau khi chuyển đổi từ tệp HEIC sang tệp JPG.",
file_transmit: "Chuyển đổi tệp tin",
combodia: 'combodia',

}
